import {isKnownStructuredTableAdapter} from 'notebook/structured-tables/StructuredTableAdapters';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';

/**
 * This utility converts between a table TYPE (used by the spreadsheet evaluator) and the
 * table KIND (internal to structured tables). Because structured tables do not have
 * a separate kind for configs, we embed both the kind and whether or not it is a config
 * table into the table type string.
 *
 * In a perfect world, table type would be an opaque (or at least rich) data type. As it is,
 * the type must be a string, so we provide these conversion utilities.
 *
 * The inverse of this function is the `tableTypeToKind` function.
 */
export default function tableTypeToKind(tableType: string): {
  kind: StructuredTableKind | null;
  isConfig: boolean;
} {
  let kindString = tableType.replace(/^structured_table_/, '');
  let isConfig = false;
  const configRegExp = /^config_/;
  if (configRegExp.test(kindString)) {
    isConfig = true;
    kindString = kindString.replace(configRegExp, '');
  }
  if (isKnownStructuredTableAdapter(kindString)) {
    return {kind: kindString as StructuredTableKind, isConfig};
  } else {
    return {kind: null, isConfig: false};
  }
}
